import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { node_server } from "../constants";
import {
	setAvailableFilters,
	setFilters,
	setIsLoading,
	setResults,
	setSelectedFilters,
} from "../store/slices/profile/projectFiltersSlice";

const filtersOptions = [
	{
		name: "Performers",
		value: "Performers",
		column: "collaborator_category",
	},
	{
		name: "Street Artists",
		value: "Street Artists",
		column: "collaborator_category",
	},
	{
		name: "TV & Film Pros",
		value: "TV & Film Pros",
		column: "collaborator_category",
	},
	{ name: "Musicians", value: "Musicians", column: "collaborator_category" },
	{
		name: "Fine Artists",
		value: "Fine Artists",
		column: "collaborator_category",
	},
	{
		name: "Fashion Designers",
		value: "Fashion Designers",
		column: "collaborator_category",
	},
	{
		name: "Space Designers",
		value: "Space Designers",
		column: "collaborator_category",
	},
	{
		name: "Culinary Artists",
		value: "Culinary Artists",
		column: "collaborator_category",
	},
	{
		name: "Digital Artists",
		value: "Digital Artists",
		column: "collaborator_category",
	},
	{ name: "Stylists", value: "Stylists", column: "collaborator_category" },
	{ name: "Marketers", value: "Marketers", column: "collaborator_category" },
	{
		name: "Technologists",
		value: "Technologists",
		column: "collaborator_category",
	},
	{ name: "Writers", value: "Writers", column: "collaborator_category" },
	{
		name: "Product Designers",
		value: "Product Designers",
		column: "collaborator_category",
	},
	{
		name: "Business People",
		value: "Business People",
		column: "collaborator_category",
	},
	{
		name: "Event Producers",
		value: "Event Producers",
		column: "collaborator_category",
	},
];

function useProjectFilters() {
	const dispatch = useDispatch();
	dispatch(setSelectedFilters(filtersOptions));
	const user = useSelector((state) => state.user.value);
	const { filters, availableFilters, selectedFilters, isLoading, results } =
		useSelector((state) => state.projectFilters);

	const [haseFetched_PF, setHasFetched_PF] = useState(false);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [projectIds, setProjectIds] = useState([]);
	const { pathname } = useLocation();

	const ITEMS_PER_PAGE = 10;

	const handleDefaultfilters = async () => {
		if (!user || !user?.id) return;

		const { data: userCreators, error } = await axios.get(
			`${node_server}/api/user/creator-types`,
			{ withCredentials: true },
		);

		if (error) console.log(error);
		if (userCreators) {
			const selected = filtersOptions.filter((option) =>
				userCreators.some((item) => option.name.includes(item.type)),
			);
			const notSelected = filtersOptions.filter((option) =>
				userCreators.every((item) => !option.name.includes(item.type)),
			);
			dispatch(setFilters(selected));
			setHasFetched_PF(true);

			dispatch(setAvailableFilters(notSelected));
		}
	};

	const handleSelectFilter = (filter) => {
		dispatch(setFilters([...filters, filter]));
		dispatch(
			setAvailableFilters(
				availableFilters.filter((f) => f.value !== filter.value),
			),
		);
	};

	const handleDeselectFilter = (filter) => {
		dispatch(setFilters(filters.filter((f) => f.value !== filter.value)));
		dispatch(setAvailableFilters([...availableFilters, filter]));
	};

	const handleRemoveFilter = (filter) => {
		dispatch(
			setSelectedFilters(
				selectedFilters.filter((f) => f.value !== filter.value),
			),
		);
		dispatch(setFilters(filters.filter((f) => f.value !== filter.value)));
		dispatch(setAvailableFilters([...availableFilters, filter]));
	};

	const handleApplyFilters = () => {
		// setFilters(selectedFilters);
		// setPage(1);  // Reset page when filters are applied
		// setResults([]);  // Clear previous results
		// setHasMore(true);  // Reset hasMore for new filter results
	};

	const handleResetFilters = async () => {
		const { data: userCreators, error } = await axios.get(
			`${node_server}/api/user/creator-types`,
			{ withCredentials: true },
		);

		if (error) console.log(error);
		if (userCreators) {
			const selected = filtersOptions.filter((option) =>
				userCreators.some((item) => option.name.includes(item.type)),
			);
			const notSelected = filtersOptions.filter((option) =>
				userCreators.every((item) => !option.name.includes(item.type)),
			);

			dispatch(setFilters(selected));
			dispatch(setAvailableFilters(notSelected));
			setPage(1);
			setHasMore(true);
		}
	};

	const fetchProjectIds = async () => {
		dispatch(setIsLoading(true));

		let ids = [];
		try {
			const response = await axios.post(
				`${node_server}api/projects-filtering`,
				filters,
			);

			ids = [...response.data.projects];
			setProjectIds([...response.data.projects]);
			dispatch(setIsLoading(false));
		} catch (error) {
			console.error(error);
		}

		return ids;
	};

	const fetchProjectData = async (ids) => {
		const offset = (page - 1) * ITEMS_PER_PAGE;
		const limit = ITEMS_PER_PAGE;
		const idsToFetch = await ids.slice(offset, offset + limit);

		if (idsToFetch.length === 0 && filters.length > 0) {
			return [];
		}

		const response = await axios.post(
			`${node_server}/api/projects/user-info-with-ids`,
			{ ids: idsToFetch },
			{
				withCredentials: true,
			},
		);

		// supabase
		//   .from("project_user_info")
		//   .select("*")
		//   .order("project_order", { ascending: true })
		//   .in("project_id", idsToFetch)
		//   .or(`is_favourite.eq.${user?.id},is_favourite.is.null`);

		if (response.status !== 200) console.error(response.data);
		if (response.data) return response.data;
	};

	const loadMoreResults = async (ids = projectIds) => {
		dispatch(setIsLoading(true));
		if (ids.length !== 0) {
			const newResults = await fetchProjectData(ids);
			if (newResults.length === 0) {
				setHasMore(false);
			} else {
				dispatch(setResults([...results, ...newResults]));
			}
		}
		dispatch(setIsLoading(false));
	};

	const fetchAndSetProjectIds = async () => {
		if (haseFetched_PF === true) {
			const ids = await fetchProjectIds();
			setPage(1);
			setHasMore(true);
			dispatch(setResults([]));
			await loadMoreResults(ids);
		}
	};

	useEffect(() => {
		handleDefaultfilters();
	}, [user]);

	useEffect(() => {
		fetchAndSetProjectIds();
	}, [filters]);

	useEffect(() => {
		if (page > 1) {
			loadMoreResults();
		}
	}, [page]);

	useEffect(() => {
		const handleScroll = () => {
			if (pathname === "/project-join" && !isLoading && hasMore) {
				if (
					window.innerHeight + window.scrollY >=
					document.documentElement.scrollHeight
				) {
					setPage((prevPage) => prevPage + 1);
					dispatch(setIsLoading(true));
				}
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [pathname, isLoading, hasMore]);

	return {
		handleSelectFilter,
		handleDeselectFilter,
		handleApplyFilters,
		handleRemoveFilter,
		handleResetFilters,
		loadMoreResults,
	};
}

export default useProjectFilters;
